import { useSelector } from "react-redux";
import ArrowSorting from "../../../components/common/ArrowSorting";
import { formatDate } from "../../../functions/dateTime/formatDate";
import { MATERIALTRANSPORTS_COLUMNS } from "../utils/siteTables.config";
import { getmaterialTransportStatus } from "../utils/siteHelpers";
import { checkNotNull } from "../../../functions/checkValue";
import MaterialActions from "./siteList/materialTransport/MaterialActions";

export const MaterialTransportList = () => {
  const vehiclesData = useSelector((state) => state.data.data);
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden mt-2">
      <div
        className={`whitespace-nowrap overflow-auto h-[calc(100vh-13em)] max-lg:h-[calc(100vh-11em)] max-md:h-[calc(100vh-11em)]`}
      >
        <table className="w-full border border-b-0">
          {/* Header */}
          <thead className="bg-[#f4f6fc] text-blue-1 uppercase text-[14px] max-lg:text-[11px] sticky top-0 2xs:max-md:top-0 z-99">
            <tr>
              {MATERIALTRANSPORTS_COLUMNS.map((c) => (
                <th key={c.title} className="text-left px-4 py-3">
                  <span className="flex items-center">
                    {c.lineBreakTitle ? (
                      <>
                        {c.lineBreakTitle[0]}
                        <br />
                        {c.lineBreakTitle[1]}
                      </>
                    ) : (
                      c.title
                    )}

                    {c.sortArrow && vehiclesData.length > 1 && (
                      <ArrowSorting
                        sortBy={c.sortBy}
                        address={c.address}
                        arrowColor="#3a4faa"
                      />
                    )}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          {/* Body */}
          <tbody className="text-[14px] max-lg:text-xs">
            {vehiclesData.length > 0 ? (
              vehiclesData.map((m, index) => (
                <tr
                  key={m.id}
                  className="border-t hover:bg-gray-50 text-gray-800 [&_td]:p-3"
                >
                  <td>{index + 1}</td>
                  <td>{m.material.name}</td>
                  <td> {m.fieldTechnician.fullName}</td>
                  <td>{m.supervisor.fullName}</td>
                  <td>{m.vehicleNumber}</td>
                  <td>{m.driverName}</td>
                  <td>{formatDate(m.dateOfTransport)}</td>
                  <td className="text-center">
                    {checkNotNull(m.quantityRequired)}
                  </td>
                  <td className="text-center">
                    {checkNotNull(m.quantityDispatchedFromFactory)}
                  </td>
                  <td className="text-center">
                    {checkNotNull(m.quantityReceivedAtSite)}
                  </td>
                  <td className="text-center">
                    {checkNotNull(m.quantityDispatchedFromSite)}
                  </td>
                  <td className="text-center">
                    {checkNotNull(m.quantityReceivedAtFactory)}
                  </td>
                  <td className="text-center">
                    {checkNotNull(m.excessAtFactory)}
                  </td>
                  <td className="text-center">{checkNotNull(m.excessAtSite)}</td>
                  <td
                    className={`status-data ${
                      getmaterialTransportStatus(m.status).color
                    }`}
                  >
                    {getmaterialTransportStatus(m.status).status}
                  </td>
                  <td>
                    <MaterialActions material={m} />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={MATERIALTRANSPORTS_COLUMNS.length}
                  className="text-center py-6 text-gray-500"
                >
                  No match the current filter.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
